module.exports = __webpack_public_path__ + "prod/1.42.2/img/initiate_bg.975970e6.png";